import { defineMessages } from 'react-intl';

const messages = defineMessages({
  defaultLeaseEndDate: {
    id: 'App.LeaseSetup.defaultLeaseEndDate',
    defaultMessage: 'Default Lease End Date',
  },
  lease12MonthsGreater: {
    id: 'App.LeaseSetup.lease12MonthsGreater',
    defaultMessage: 'Lease 12 months+',
  },
  lease12MonthsLesser: {
    id: 'App.LeaseSetup.lease12MonthsLesser',
    defaultMessage: 'Lease < 12 months',
  },

  calculatedDate: {
    id: 'App.LeaseSetup.calculatedDate',
    defaultMessage: '“Calculated date”',
  },
  tooltipLine1: {
    id: 'App.LeaseSetup.tooltipLine1',
    /* eslint-disable max-len */
    defaultMessage:
      'applies an end date that matches the same calendar day as the start date, based on the full lease term.',
  },
  calculatedDateExample: {
    id: 'App.LeaseSetup.calculatedDateExample',
    defaultMessage:
      'For example, a lease starting on 5/15/25 with a 12-month term will end on 5/15/26.',
  },
  lastDayOfMonth: {
    id: 'App.LeaseSetup.lastDayOfMonth',
    defaultMessage: '“Last day of month”',
  },
  tooltipLine2: {
    id: 'App.LeaseSetup.tooltipLine2',
    defaultMessage:
      'applies an end date that is the last day of the calendar month resulting from the lease start date and term.',
  },
  lastDayOfMonthExample: {
    id: 'App.LeaseSetup.lastDayOfMonthExample',
    defaultMessage:
      'For example, a lease starting on 5/15/25 with a 12-month term will end on 5/31/26.',
  },
  lastDayOfPriorMonth: {
    id: 'App.LeaseSetup.lastDayOfPriorMonth',
    defaultMessage: '“Last day of prior month”',
  },
  tooltipLine3: {
    id: 'App.LeaseSetup.tooltipLine3',
    defaultMessage:
      'applies an end date that is the last day of the month prior to the one resulting from the lease start date and term.',
  },
  lastDayOfPriorMonthExample: {
    id: 'App.LeaseSetup.lastDayOfPriorMonthExample',
    defaultMessage:
      'For example, a lease starting on 5/15/25 with a 12-month term will end on 4/30/26.',
  },
  tooltipTitle: {
    id: 'App.LeaseSetup.tooltipTitle',
    defaultMessage: 'For each lease length, you may choose from three options:',
  },
});

export default messages;
